var _excluded = ["centerTo", "minScale", "maxScale", "maxZoomLevel", "minZoomLevel", "minResolution", "maxResolution"];
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import olSourceVector from 'ol/source/Vector';
import olLayerVector from 'ol/layer/Vector';
import { unByKey } from 'ol/Observable.js';
import { fromExtent } from 'ol/geom/Polygon';
import olFormatWKT from 'ol/format/WKT';
import olFormatGeoJSON from 'ol/format/GeoJSON';
import jstsOL3Parser from 'jsts/org/locationtech/jts/io/OL3Parser';
import { BufferOp } from 'jsts/org/locationtech/jts/operation/buffer';
import * as olGeom from 'ol/geom';
import LinearRing from 'ol/geom/LinearRing';
import GeometryCollection from 'ol/geom/GeometryCollection';
import { LAYER_ID, LAYER_TYPE, FTR_PROPERTY_ID, SERVICE_LAYER_REQUEST } from '../../domain/constants';
import { filterOptionalStyle } from '../../oskariStyle/filter';
import { applyOpacityToStyle } from '../../oskariStyle/generator.ol';
import { getZoomLevelHelper, getScalesFromOptions } from '../../util/scale';
import { interpolateLab } from 'd3';
import './vectorlayer';
import './request/AddFeaturesToMapRequest';
import './request/AddFeaturesToMapRequestHandler';
import './request/RemoveFeaturesFromMapRequest';
import './request/RemoveFeaturesFromMapRequestHandler';
import './request/ZoomToFeaturesRequest';
import './request/ZoomToFeaturesRequestHandler';
var olParser = new jstsOL3Parser();
olParser.inject(olGeom.Point, olGeom.LineString, LinearRing, olGeom.Polygon, olGeom.MultiPoint, olGeom.MultiLineString, olGeom.MultiPolygon, GeometryCollection);

/**
 * @class Oskari.mapframework.mapmodule.VectorLayerPlugin
 * Provides functionality to draw vector layers on the map
 */
Oskari.clazz.define('Oskari.mapframework.mapmodule.VectorLayerPlugin', function () {
  this._features = {};
  this._olLayers = {};
  this._oskariLayers = {};
  this._supportedFormats = {};
  this._olLayerPrefix = 'vectorlayer_';
  this._featureStyles = {};
  this._layerStyles = {};
  this._defaultStyle = {
    fill: {
      color: 'rgba(255,0,255,0.2)'
    },
    stroke: {
      color: 'rgba(0,0,0,1)',
      width: 2
    },
    image: {
      radius: 4,
      fill: {
        color: 'rgba(0,0,0,1)'
      }
    },
    text: {
      scale: 1.3,
      fill: {
        color: 'rgba(0,0,0,1)'
      },
      stroke: {
        color: 'rgba(255,255,255,1)',
        width: 2
      }
    }
  };
  this._nextFeatureId = 0;
  this._hoverState = null;
  this._log = Oskari.log('VectorLayerPlugin');
  this._styleCache = {};
  this._animatingFeatures = {};
  this._name = 'VectorLayerPlugin';
  this._asyncLayers = {};
}, {
  __name: 'Oskari.mapframework.mapmodule.VectorLayerPlugin',
  /**
   * @method register
   * Interface method for the plugin protocol
   */
  register: function register() {
    this.getMapModule().setLayerPlugin('vectorlayer', this);
  },
  /**
   * @method unregister
   * Interface method for the plugin protocol
   */
  unregister: function unregister() {
    this.getMapModule().setLayerPlugin('vectorlayer', null);
  },
  /**
   * @method _startPluginImpl
   * @private
   * Start plugin implementation
   *
   */
  _startPluginImpl: function _startPluginImpl() {
    var me = this;
    me.registerVectorFormats();
    me._createConfiguredLayers();
    me._registerToFeatureService();

    // listen to application started event and register RPC functions.
    Oskari.on('app.start', function (details) {
      // Register RPC functions
      me.registerRPCFunctions();
    });
  },
  /**
   * @method  @private _createConfiguredLayers Create configured layers an their styles
   */
  _createConfiguredLayers: function _createConfiguredLayers() {
    var me = this;
    var conf = me.getConfig();
    if (conf.layers) {
      for (var i = 0; i < conf.layers.length; i++) {
        var layer = conf.layers[i];
        var layerId = layer.id;
        var layerStyle = layer.style;
        if (!me._features[layerId]) {
          me._features[layerId] = [];
        }
        var opacity = 100;
        var vectorSource = new olSourceVector();
        var olLayer = new olLayerVector({
          source: vectorSource
        });
        olLayer.set(LAYER_ID, layerId, true);
        olLayer.setOpacity(opacity);
        me.getMapModule().addOverlayLayer(olLayer);
        me._olLayers[layerId] = olLayer;
        me._layerStyles[layerId] = layerStyle;
      }
    }
  },
  /**
   * @method _createEventHandlers
   * Create event handlers
   * @private
   *
   */
  _createEventHandlers: function _createEventHandlers() {
    var me = this;
    return {
      AfterMapLayerRemoveEvent: function AfterMapLayerRemoveEvent(event) {
        me.afterMapLayerRemoveEvent(event);
      },
      AfterChangeMapLayerOpacityEvent: function AfterChangeMapLayerOpacityEvent(event) {
        me._afterChangeMapLayerOpacityEvent(event);
      },
      AfterMapLayerAddEvent: function AfterMapLayerAddEvent(event) {
        var layer = event.getMapLayer();
        if (!layer.isLayerOfType('VECTOR')) {
          return;
        }
        var layerId = layer.getId();
        // registered layer can be added without request
        // create/get ol layer if async isn't stored
        var olLayer = me._asyncLayers[layerId] || me._getOlLayer(layer);
        if (olLayer) {
          me.getMapModule().addLayer(olLayer);
          delete me._asyncLayers[layerId];
        }
      }
    };
  },
  /**
   * @method _afterChangeMapLayerOpacityEvent
   * Handle AfterChangeMapLayerOpacityEvent
   * @private
   * @param {Oskari.mapframework.event.common.AfterChangeMapLayerOpacityEvent} event
   */
  _afterChangeMapLayerOpacityEvent: function _afterChangeMapLayerOpacityEvent(event) {
    var me = this;
    var layer = event.getMapLayer();
    if (!layer.isLayerOfType('VECTOR')) {
      return;
    }
    this._log.debug('Setting Layer Opacity for ' + layer.getId() + ' to ' + layer.getOpacity());
    me.handleLayerOpacity(layer, layer.getOpacity() / 100, true);
  },
  /**
   * @method _registerToFeatureService
   * @private
   * Registers vector layer type to feature service for tooltip, click and layer requests.
   */
  _registerToFeatureService: function _registerToFeatureService() {
    var defaultHandlerDef = [SERVICE_LAYER_REQUEST];
    var vectorFeatureService = this.getSandbox().getService('Oskari.mapframework.service.VectorFeatureService');
    vectorFeatureService.registerLayerType('vector', this, defaultHandlerDef);
  },
  /**
   * @method onLayerRequest VectorFeatureService handler impl method
   * Handles VectorLayerRequest.
   *
   * @param { Oskari.mapframework.bundle.mapmodule.request.VectorLayerRequest } request
   */
  onLayerRequest: function onLayerRequest(request) {
    this.prepareVectorLayer(request.getOptions());
  },
  /**
   * @method onMapHover VectorFeatureService handler impl method
   * Handles feature highlighting on map hover.
   *
   * @param { Oskari.mapframework.event.common.MouseHoverEvent } event
   * @param { olFeature } feature
   * @param { olVectorLayer } layer
   */
  onMapHover: function onMapHover(event, feature, layer) {
    var oldHoverState = this._hoverState;
    this._hoverState = null;
    if (feature) {
      this._applyHoverStyle(feature, layer);
      this._hoverState = {
        feature: feature,
        layer: layer
      };
    }
    // Remove highlighting from the previously hovered feature
    if (oldHoverState && oldHoverState.feature !== feature) {
      this._applyOriginalStyle(oldHoverState.feature, oldHoverState.layer);
    }
    // Update map cursor if feature is/was hovered
    if (oldHoverState || this._hoverState) {
      var cursor = this._hoverState ? this._hoverState.feature.get('oskari-cursor') : null;
      // we could use setCursorStyle() but it saves the current cursor on map module
      // so we couldn't restore it with getCursorStyle()
      var mapEl = this.getMapModule().getMapEl();
      if (cursor) {
        mapEl.css('cursor', cursor);
      } else {
        mapEl.css('cursor', this.getMapModule().getCursorStyle());
      }
    }
  },
  /**
   * @method _applyHoverStyle
   *
   * Changes feature's style and preserves the original style to go back to.
   *
   * @param {ol/Feature} feature ol feature
   * @param {ol/layer/Vector || object} layer ol layer or layer id
   */
  _applyHoverStyle: function _applyHoverStyle(feature, layer) {
    if (_typeof(layer) !== 'object') {
      layer = this._getOlLayer(layer);
    }
    var layerId = layer.get(LAYER_ID);
    var oskariLayer = this._findOskariLayer(layerId);
    if (!oskariLayer) {
      return;
    }
    var hoverOptions = oskariLayer.getHoverOptions();
    if (!hoverOptions || !hoverOptions.featureStyle) {
      return;
    }
    if (hoverOptions.filter) {
      var match = hoverOptions.filter.find(function (cur) {
        return cur.key && feature.get(cur.key) === cur.value;
      });
      if (!match) {
        return;
      }
    }
    var ftrStyles = this.getCachedStyles(layerId, this.getFeatureId(feature));
    if (!ftrStyles || ftrStyles.hoverActive) {
      return;
    }
    var hoverStyleDef = hoverOptions.featureStyle;
    if (!ftrStyles.olHover) {
      var hoverStyle = hoverStyleDef.inherit ? jQuery.extend(true, {}, ftrStyles.oskari || {}, hoverStyleDef) : hoverStyleDef;
      var olHover = this.getMapModule().getStyle(hoverStyle);
      var zIndex = this.getStyleZIndex(ftrStyles.ol);
      this.setStyleZIndex(olHover, zIndex);
      this._setFeatureLabel(feature, hoverStyle, olHover);
      ftrStyles.olHover = olHover;
    }
    ftrStyles.hoverActive = true;
    feature.setStyle(ftrStyles.olHover);
  },
  /**
   * @method _applyOriginalStyle
   *
   * Switch back to the original style.
   *
   * @param {ol/Feature} feature ol feature
   * @param {ol/layer/Vector} layer ol layer
   */
  _applyOriginalStyle: function _applyOriginalStyle(feature, layer) {
    var ftrStyles = this.getCachedStyles(layer.get(LAYER_ID), this.getFeatureId(feature));
    if (!ftrStyles || !ftrStyles.ol || !ftrStyles.hoverActive) {
      return;
    }
    feature.setStyle(ftrStyles.ol);
    ftrStyles.hoverActive = false;
  },
  /**
   * @method registerVectorFormat
   * Adds vector format to props of known formats
   *
   * @param  {String} mimeType mime type
   * @param  {Function} formatImpl format implementation
   */
  registerVectorFormat: function registerVectorFormat(mimeType, formatImpl) {
    this._supportedFormats[mimeType] = formatImpl;
  },
  /**
   * @method registerVectorFormats
   * Registers default vector formats
   */
  registerVectorFormats: function registerVectorFormats() {
    var me = this;
    this.registerVectorFormat('application/json', new olFormatGeoJSON({}));
    this.registerVectorFormat('application/nlsfi-x-openlayers-feature', function () {
      this.read = function (data) {
        return data;
      };
    });
    me.registerVectorFormat('GeoJSON', new olFormatGeoJSON());
    me.registerVectorFormat('WKT', new olFormatWKT({}));
  },
  /**
   * @method removeFeaturesFromMap
   * @public
   * Removes all/selected features from map.
   *
   * @param {String} identifier the feature attribute identifier
   * @param {String/Array} value the feature identifier value or values in array
   * @param {ol/layer/Vector} layer object OR {String} layerId
   */
  removeFeaturesFromMap: function removeFeaturesFromMap(identifier, value, layer) {
    var me = this;
    var olLayer;
    var layerId;
    if (layer && layer !== null) {
      if (layer instanceof olLayerVector) {
        layerId = layer.get(LAYER_ID);
      } else if (typeof layer === 'string' || typeof layer === 'number') {
        layerId = layer;
      }
      olLayer = me._olLayers[layerId];
      if (!olLayer) {
        return;
      }
    }
    if (olLayer) {
      // Removes only wanted features from the given maplayer
      if (identifier && identifier !== null && value && value !== null) {
        me._removeFeaturesByAttribute(olLayer, identifier, value);
      } else {
        // remove all features from the given layer
        this._removeAllFeatures(olLayer);
      }
    } else if (!layer) {
      // Removes all features from all layers if layer is not specified
      for (layerId in me._olLayers) {
        if (me._olLayers.hasOwnProperty(layerId)) {
          olLayer = me._olLayers[layerId];
          this._removeAllFeatures(olLayer);
        }
      }
    }
  },
  _removeAllFeatures: function _removeAllFeatures(olLayer) {
    var source = olLayer.getSource();
    var formatter = this._supportedFormats.GeoJSON;
    var removeEvent = Oskari.eventBuilder('FeatureEvent')().setOpRemove();
    var layerId = olLayer.get(LAYER_ID);
    source.forEachFeature(function (f) {
      var geojson = formatter.writeFeaturesObject([f]);
      removeEvent.addFeature(f.getId(), geojson, layerId);
    });
    source.clear();
    // remove from "cache"
    delete this._features[layerId];
    delete this._styleCache[layerId];
    if (removeEvent.hasFeatures()) {
      this.getSandbox().notifyAll(removeEvent);
    }
  },
  _removeFeaturesByAttribute: function _removeFeaturesByAttribute(olLayer, identifier, value) {
    var _this = this;
    var source = olLayer.getSource();
    var featuresToRemove = [];
    var formatter = this._supportedFormats.GeoJSON;
    var removeEvent = Oskari.eventBuilder('FeatureEvent')().setOpRemove();
    var layerId = olLayer.get(LAYER_ID);
    if (Array.isArray(value)) {
      source.forEachFeature(function (f) {
        if (value.includes(f.get(identifier))) {
          featuresToRemove.push(f);
        }
      });
    } else {
      source.forEachFeature(function (f) {
        if (f.get(identifier) === value) {
          featuresToRemove.push(f);
        }
      });
    }
    // If there is no features to remove then return
    if (featuresToRemove.length === 0) {
      return;
    }
    // notify other components of removal
    featuresToRemove.forEach(function (f) {
      source.removeFeature(f);
      // add to event
      var geojson = formatter.writeFeaturesObject([f]);
      removeEvent.addFeature(f.getId(), geojson, layerId);
      // remove from "cache"
      _this._removeFromCache(layerId, f);
    });
    this.getSandbox().notifyAll(removeEvent);
  },
  _removeFromCache: function _removeFromCache(layerId, feature) {
    var storedFeatures = this._features[layerId];
    if (storedFeatures) {
      for (var i = 0; i < storedFeatures.length; i++) {
        var featuresInDataset = storedFeatures[i].data;
        for (var j = 0; j < featuresInDataset.length; j++) {
          if (feature === featuresInDataset[j]) {
            featuresInDataset.splice(j, 1);
          }
        }
        if (!featuresInDataset.length) {
          // remove block if empty
          storedFeatures.splice(i, 1);
        }
      }
    }
    if (this._styleCache[layerId]) {
      delete this._styleCache[layerId][this.getFeatureId(feature)];
    }
  },
  _getGeometryType: function _getGeometryType(geometry) {
    if (typeof geometry === 'string' || geometry instanceof String) {
      return 'WKT';
    }
    return 'GeoJSON';
  },
  _getOlLayer: function _getOlLayer(layer) {
    var me = this;
    if (!layer || layer.getLayerType() !== 'vector') {
      return null;
    }
    var olLayer = me._olLayers[layer.getId()];
    if (!olLayer) {
      olLayer = new olLayerVector({
        source: new olSourceVector()
      });
      // Set oskari properties
      var silent = true;
      olLayer.set(LAYER_ID, layer.getId(), silent);
      olLayer.set(LAYER_TYPE, layer.getLayerType(), silent);
      me._olLayers[layer.getId()] = olLayer;
      var zoomLevelHelper = getZoomLevelHelper(this.getMapModule().getScaleArray());
      // Set min max zoom levels that layer should be visible in
      zoomLevelHelper.setOLZoomLimits(olLayer, layer.getMinScale(), layer.getMaxScale());
      if (layer.getOptions().showLayer) {
        me._asyncLayers[layer.getId()] = olLayer;
      } else {
        me.getMapModule().addOverlayLayer(olLayer);
      }
    }
    olLayer.setOpacity(layer.getOpacity() / 100);
    olLayer.setVisible(layer.isVisible());
    return olLayer;
  },
  /**
   * Handles layer opacity.
   * @param  {Oskari.mapframework.domain.VectorLayer} layer
   * @param  {Double} opacity
   */
  handleLayerOpacity: function handleLayerOpacity(layer, opacity) {
    var _this2 = this;
    var me = this;
    var olLayer = me._olLayers[layer.getId()];
    if (olLayer) {
      olLayer.setOpacity(opacity);
      if (this.getMapModule().getSupports3D()) {
        olLayer.getSource().forEachFeature(function (f) {
          _this2.setStyleOpacity(f.getStyle(), opacity);
          f.changed();
        });
      }
    }
  },
  /**
   * @method _findOskariLayer
   * @private
   *
   * Returns cached Oskari layer by id.
   *
   * @param {String} id layer id
   * @return {Oskari.mapframework.domain.VectorLayer} layer object
   */
  _findOskariLayer: function _findOskariLayer(id) {
    var layer = this._oskariLayers[id];
    if (!layer) {
      var mapLayerService = this._sandbox.getService('Oskari.mapframework.service.MapLayerService');
      layer = mapLayerService.findMapLayer(id);
      if (layer && layer.getLayerType() !== 'vector') {
        return null;
      }
    }
    return layer;
  },
  /**
   * @method prepareVectorLayer
   * @public
   *
   * Creates a new layer or updates an existing one if found by options.layerId.
   *
   * @param {Object} options layer properties
   * @return {Oskari.mapframework.domain.VectorLayer} layer object
   */
  prepareVectorLayer: function prepareVectorLayer(options) {
    options = options || {};
    var mapLayerService = this._sandbox.getService('Oskari.mapframework.service.MapLayerService');
    if (!options.layerId) {
      options.layerId = 'VECTOR';
    }
    var layer = this._findOskariLayer(options.layerId);
    if (!layer) {
      if (options.remove === true) {
        // removal was requested for unrecognized layer id -> don't need to do anything
        return;
      }
      layer = Oskari.clazz.create('Oskari.mapframework.domain.VectorLayer');
      layer.setId(options.layerId);
      layer.setName(options.layerName || 'VECTOR');
      layer.setGroups([{
        id: options.layerId,
        name: options.layerInspireName || 'VECTOR'
      }]);
      layer.setOrganizationName(options.layerOrganizationName || 'VECTOR');
      layer.setDescription(options.layerDescription);
      if (typeof options.opacity !== 'undefined') {
        layer.setOpacity(options.opacity);
      }
      layer.setVisible(true);
      layer.setOptions({
        showLayer: options.showLayer
      });
      this._setHoverOptions(layer, options);
      // scale limits
      var mapModule = this.getMapModule();
      var scales = getScalesFromOptions(mapModule.getScaleArray(), mapModule.getResolutionArray(), options);
      layer.setMinScale(scales.min);
      layer.setMaxScale(scales.max);
      if (options.layerPermissions) {
        for (var permission in options.layerPermissions) {
          if (options.layerPermissions.hasOwnProperty(permission)) {
            layer.addPermission(permission, options.layerPermissions[permission]);
          }
        }
      }
      this._getOlLayer(layer);
      this._oskariLayers[layer.getId()] = layer;
    } else if (this._containsLayerOptions(options)) {
      layer = this._updateVectorLayer(layer, options);
    }
    if (options.showLayer) {
      // Show layer in layer selector
      if (!mapLayerService.findMapLayer(layer.getId())) {
        // check if we have a group for this layer in maplayer service
        var groupForLayer = layer.getGroups()[0];
        var mapLayerGroup = mapLayerService.findLayerGroupById(groupForLayer.id);
        if (!mapLayerGroup) {
          var group = {
            id: groupForLayer.id,
            name: groupForLayer.name
          };
          mapLayerService.addLayerGroup(Oskari.clazz.create('Oskari.mapframework.domain.MaplayerGroup', group));
        }
        mapLayerService.addLayer(layer);
      }
      if (options.showLayer !== 'registerOnly' && !this._sandbox.findMapLayerFromSelectedMapLayers(layer.getId())) {
        var request = Oskari.requestBuilder('AddMapLayerRequest')(layer.getId());
        this._sandbox.request(this, request);
      } else if (options.showLayer === 'registerOnly') {
        // remove maplayer from map because _getOlLayer adds it to map and this is only for registering layer
        // FIXME: refactor _getOlLayer -> handle get, update and add separately
        this.removeMapLayerFromMap(layer);
      }
    }
    return layer;
  },
  /**
   * @method _updateVectorLayer
   * @private
   *
   * Updates layer properties
   *
   * @param {Oskari.mapframework.domain.VectorLayer} layer layer to update
   * @param {Object} options update properties
   * @return {Oskari.mapframework.domain.VectorLayer} layer object
   */
  _updateVectorLayer: function _updateVectorLayer(layer, options) {
    if (!layer || !options) {
      // nothing to do here
      return layer;
    }
    var sandbox = this.getSandbox();
    var mapLayerService = sandbox.getService('Oskari.mapframework.service.MapLayerService');
    if (options.remove) {
      var request = Oskari.requestBuilder('RemoveMapLayerRequest')(layer.getId());
      this._sandbox.request(this, request);
      mapLayerService.removeLayer(layer);
      this.removeMapLayerFromMap(layer);
      delete this._oskariLayers[layer.getId()];
      return layer;
    }
    var layerUpdate = false;
    var olUpdate = false;
    var layerName = options.layerName,
      layerOrganizationName = options.layerOrganizationName,
      layerDescription = options.layerDescription,
      showLayer = options.showLayer;
    if (layerName && layer.getName() !== layerName) {
      layer.setName(layerName);
      layerUpdate = true;
    }
    if (layerOrganizationName && layer.getOrganizationName() !== layerOrganizationName) {
      layer.setOrganizationName(layerOrganizationName);
      layerUpdate = true;
    }
    if (layerDescription && layer.getDescription() !== layerDescription) {
      layer.setDescription(layerDescription);
      layerUpdate = true;
    }
    if (typeof options.opacity !== 'undefined') {
      layer.setOpacity(options.opacity);
      olUpdate = true;
    }
    if (typeof showLayer !== 'undefined') {
      var layerOpts = layer.getOptions() || {};
      layer.setOptions(_objectSpread(_objectSpread({}, layerOpts), {}, {
        showLayer: showLayer
      }));
      olUpdate = true;
    }
    if (olUpdate) {
      // Apply changes to ol layer
      this._getOlLayer(layer);
    }
    this._setHoverOptions(layer, options);
    var lyrInService = mapLayerService.findMapLayer(layer.getId());
    if (lyrInService && layerUpdate) {
      // Send layer updated notification
      var evt = Oskari.eventBuilder('MapLayerEvent')(layer.getId(), 'update');
      // this causes performance problems with layer listing when spammed
      // only send event if name/organization or description was changed
      sandbox.notifyAll(evt);
    }
    return layer;
  },
  _setHoverOptions: function _setHoverOptions(layer, options) {
    var hover = options.hover;
    if (hover) {
      layer.setHoverOptions(hover);
      if (hover.filter) {
        if (!Array.isArray(hover.filter)) {
          hover.filter = [hover.filter];
        }
      }
      // tooltip overlay is handled by VectorFeatureService
      if (Array.isArray(hover.content)) {
        var vectorFeatureService = this.getSandbox().getService('Oskari.mapframework.service.VectorFeatureService');
        vectorFeatureService.setVectorLayerHoverTooltip(layer);
      }
    }
  },
  /**
   * @method _containsLayerOptions
   * @private
   * Check if options contains layer specific settings.
   *
   * @return {boolean} true if options contains layer specific settings
   */
  _containsLayerOptions: function _containsLayerOptions(options) {
    return options && !!(options.layerName || options.layerOrganizationName || typeof options.opacity !== 'undefined' || options.hover || options.layerDescription || typeof options.showLayer !== 'undefined' || typeof options.remove !== 'undefined');
  },
  /**
   * @method addFeaturesToMap
   * @public
   * Add feature on the map
   *
   * For loading indication:
      // for each feature at start:
      me.getMapModule().loadingState(layerId, true);
      // for each feature after processed:
      me.getMapModule().loadingState(layerId, false);
      // for each feature that couldn't be added to map:
      me.getMapModule().loadingState(layerId, null, true);
   *
   * @param {Object} geometry the geometry WKT string or GeoJSON object or object containing feature properties for updating
   * @param {Object} options additional options
   */
  addFeaturesToMap: function addFeaturesToMap(geometry) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var me = this;
    var geometryType = me._getGeometryType(geometry);
    var format = me._supportedFormats[geometryType];
    var olLayer;
    var layer;
    var vectorSource;
    var layerId = options.layerId || 'VECTOR';

    // if there's no layerId provided -> Just use a generic vector layer for all.
    if (!options.layerId) {
      options.layerId = layerId;
    }
    if (!options.attributes) {
      options.attributes = {};
    }
    if (!me._features[layerId]) {
      me._features[layerId] = [];
    }
    // Remove scale limit options that are only meant to be used to limit zooming with AddFeaturesToMapRequest
    // but if they are passed to prepareVectorLayer() they also limit visibility of layers.
    // The same prepareVectorLayer() function is used for VectorLayerRequest where we DO want to limit visibility
    // Note! Only centerTo, minScale and maxZoomLevel are used. The others are just removed from layerOptions
    // so we don't accidentally limit visibility when passing them in AddFeaturesToMapRequest
    // Disable ESLint since it otherwise complains about unused vars
    // eslint-disable-next-line no-unused-vars
    var centerTo = options.centerTo,
      minScale = options.minScale,
      maxScale = options.maxScale,
      maxZoomLevel = options.maxZoomLevel,
      minZoomLevel = options.minZoomLevel,
      minResolution = options.minResolution,
      maxResolution = options.maxResolution,
      layerOptions = _objectWithoutProperties(options, _excluded);
    layer = me.prepareVectorLayer(layerOptions);
    olLayer = me._getOlLayer(layer);
    vectorSource = olLayer.getSource();
    if (!me.getMapModule().isValidGeoJson(geometry) && _typeof(geometry) === 'object') {
      // when updating style -> options has new style and "geometry" is used for
      // selecting feature to update like in thematic maps: { id: regionid }
      me.getMapModule().loadingState(layerId, true);
      for (var key in geometry) {
        me.getMapModule().loadingState(layerId, true);
        me._updateFeature(layerOptions, key, geometry[key]);
        me.getMapModule().loadingState(layerId, false);
      }
      me._applyPrioOnSource(layerOptions.layerId, vectorSource, layerOptions.prio);
      me.getMapModule().loadingState(layerId, false);
      return;
    }
    if (!format || !geometry) {
      return;
    }
    if (geometryType === 'GeoJSON' && !me.getMapModule().isValidGeoJson(geometry)) {
      return;
    }
    // initial loading stopped at end of function
    this.getMapModule().loadingState(layerId, true);
    var features = format.readFeatures(geometry);
    // add cursor if defined so
    if (layerOptions.cursor) {
      layerOptions.attributes['oskari-cursor'] = layerOptions.cursor;
    }
    if (layerOptions.attributes !== null && features instanceof Array && features.length) {
      features.forEach(function (ftr) {
        ftr.setProperties(layerOptions.attributes);
      });
    }
    features.forEach(function (feature) {
      // start loading/feature
      me.getMapModule().loadingState(layerId, true);
      if (typeof feature.getId() === 'undefined' && typeof feature.get(FTR_PROPERTY_ID) === 'undefined') {
        var id = 'F' + me._nextFeatureId++;
        feature.setId(id);
        // setting id using set(key, value) to make id-property asking by get('id') possible
        feature.set(FTR_PROPERTY_ID, id);
      }
      me.setFeatureStyle(layerOptions, feature, false);
    });
    // clear old features if defined so
    if (layerOptions.clearPrevious === true) {
      vectorSource.clear();
      me._features[layerId] = [];
    }
    // prio handling
    var prio = layerOptions.prio || 0;
    me._features[layerId].push({
      data: features,
      prio: prio
    });
    me._applyPrioOnSource(layerId, vectorSource, layerOptions.prio);
    vectorSource.addFeatures(features);

    // notify other components that features have been added
    var formatter = this._supportedFormats.GeoJSON;
    var sandbox = this.getSandbox();
    var addEvent = Oskari.eventBuilder('FeatureEvent')().setOpAdd();
    var errorEvent = Oskari.eventBuilder('FeatureEvent')().setOpError('feature has no geometry');
    features.forEach(function (feature) {
      var geojson = formatter.writeFeaturesObject([feature]);
      var event = addEvent;
      if (!feature.getGeometry()) {
        event = errorEvent;
        // signal error on loading
        me.getMapModule().loadingState(layerId, null, true);
      } else {
        // signal end of loading
        me.getMapModule().loadingState(layerId, false);
      }
      event.addFeature(feature.getId(), geojson, olLayer.get(LAYER_ID));
    });
    if (errorEvent.hasFeatures()) {
      sandbox.notifyAll(errorEvent);
    }
    if (addEvent.hasFeatures()) {
      sandbox.notifyAll(addEvent);
    }
    // re-position map when opted
    if (centerTo === true) {
      var extent = vectorSource.getExtent();
      me.getMapModule().zoomToExtent(extent);

      // Check scale if defined so. Scale decreases when the map is zoomed in. Scale increases when the map is zoomed out.
      if (typeof minScale === 'number') {
        var currentScale = this.getMapModule().getMapScale();
        if (currentScale < minScale) {
          this.getMapModule().zoomToScale(minScale, true);
        }
      }
      // Check max zoom if defined so. Zoom increases when the map is zoomed in. Zoom decreases when the map is zoomed out.
      if (typeof maxZoomLevel === 'number') {
        var currentZoom = this.getMapModule().getMapZoom();
        if (currentZoom > maxZoomLevel) {
          this.getMapModule().setZoomLevel(maxZoomLevel);
        }
      }
    }
    me.getMapModule().loadingState(layerId, false);
  },
  /**
   * @method _applyPrioOnSource
   * Set feature zIndexes based on cached prio values.
   *
   * @param {String} layerId
   * @param {olSourceVector} source
   * @param {Number} prio
   */
  _applyPrioOnSource: function _applyPrioOnSource(layerId, source, prio) {
    var _this3 = this;
    if (isNaN(prio) || !source) {
      return;
    }
    var zIndex = 0;
    this._features[layerId].sort(function (a, b) {
      return b.prio - a.prio;
    });
    this._features[layerId].forEach(function (featObj) {
      featObj.data.forEach(function (feature) {
        _this3.updateCachedZIndex(layerId, feature, zIndex);
        _this3.setStyleZIndex(feature.getStyle(), zIndex);
        zIndex++;
      });
    });
    // apply changes on map
    this.getMapModule().getMap().render();
  },
  /**
   * @method _updateFeature
   * @public
   * Updates feature's style
   *
   * @param {Object} options additional options
   * @param {String} propertyName
   * @param {String} value
   * @param {Number} animationDuration
   */
  _updateFeature: function _updateFeature(options, propertyName, value) {
    var _this4 = this;
    var prio = options.prio,
      layerId = options.layerId,
      featureStyle = options.featureStyle;
    var values = Array.isArray(value) ? value : [value];
    var searchValues = values.map(function (cur) {
      return _typeof(cur) === 'object' ? cur.value : cur;
    });
    var searchOptions = _defineProperty({}, propertyName, searchValues);
    this.getFeaturesMatchingQuery([layerId], searchOptions).forEach(function (feature) {
      var updateValue = values.find(function (cur) {
        return _typeof(cur) === 'object' && feature.get(propertyName) === cur.value;
      });
      if (updateValue && updateValue.properties) {
        Object.keys(updateValue.properties).forEach(function (key) {
          return feature.set(key, updateValue.properties[key]);
        });
      }
      if (featureStyle) {
        _this4.setFeatureStyle(options, feature, true);
      }
      _this4._updateCachedPrio(layerId, feature, prio);
      var formatter = _this4._supportedFormats.GeoJSON;
      var addEvent = Oskari.eventBuilder('FeatureEvent')().setOpAdd();
      var errorEvent = Oskari.eventBuilder('FeatureEvent')().setOpError('feature has no geometry');
      var geojson = formatter.writeFeaturesObject([feature]);
      var event = addEvent;
      if (!feature.getGeometry()) {
        event = errorEvent;
      }
      event.addFeature(feature.getId(), geojson, layerId);
      if (errorEvent.hasFeatures()) {
        _this4.getSandbox().notifyAll(errorEvent);
      }
      if (addEvent.hasFeatures()) {
        _this4.getSandbox().notifyAll(addEvent);
      }
    });
  },
  /**
   * @method _updateCachedPrio
   * Moves the feature to a dataset having the specified prio
   *
   * @param {String} layerId
   * @param {olFeature} feature
   * @param {Number} prio
   */
  _updateCachedPrio: function _updateCachedPrio(layerId, feature, prio) {
    if (!layerId || !feature || isNaN(prio)) {
      return;
    }
    var datasets = this._features[layerId];
    var oldDataset = datasets.find(function (cur) {
      return cur.data.find(function (ftr) {
        return ftr === feature;
      });
    });
    if (oldDataset && oldDataset.prio !== prio) {
      oldDataset.data.splice(oldDataset.data.indexOf(feature), 1);
      var newDataset = datasets.find(function (cur) {
        return cur.prio === prio;
      });
      if (newDataset) {
        newDataset.data.push(feature);
      } else {
        datasets.push({
          data: [feature],
          prio: prio
        });
      }
    }
  },
  _animateFillColorChange: function _animateFillColorChange(feature, newStyle, duration) {
    var me = this;
    var featureId = me.getFeatureId(feature);
    var getFillColor = function getFillColor(styles) {
      var fill = Array.isArray(styles) && styles.length ? styles[0].getFill() : undefined;
      return fill ? fill.getColor() : undefined;
    };
    var oldColor = getFillColor(feature.getStyle());
    var newColor = getFillColor(newStyle);
    if (!oldColor || !newColor || !duration) {
      // No animation. Just set the style.
      delete me._animatingFeatures[featureId];
      feature.setStyle(newStyle);
      return;
    }
    me._animatingFeatures[featureId] = feature;
    var start = new Date().getTime();
    var map = me.getMapModule().getMap();
    var listenerKey = map.on('postcompose', animate);
    function animate(event) {
      if (!me._animatingFeatures[featureId]) {
        unByKey(listenerKey);
        return;
      }
      var elapsed = event.frameState.time - start;
      var elapsedRatio = elapsed / duration;
      if (elapsed > duration) {
        unByKey(listenerKey);
        feature.setStyle(newStyle);
        return;
      }
      var olStyles = feature.getStyle();
      olStyles[0].getFill().setColor(interpolateLab(oldColor, newColor)(elapsedRatio));
      feature.setStyle(olStyles);
    }
    // Start animation
    map.render();
  },
  /**
   * @method _createRequestHandlers
   * @private
   * Create request handlers.
   */
  _createRequestHandlers: function _createRequestHandlers() {
    var me = this;
    var sandbox = me.getSandbox();
    return {
      'MapModulePlugin.AddFeaturesToMapRequest': Oskari.clazz.create('Oskari.mapframework.bundle.mapmodule.request.AddFeaturesToMapRequestHandler', sandbox, me),
      'MapModulePlugin.RemoveFeaturesFromMapRequest': Oskari.clazz.create('Oskari.mapframework.bundle.mapmodule.request.RemoveFeaturesFromMapRequestHandler', sandbox, me),
      'MapModulePlugin.ZoomToFeaturesRequest': Oskari.clazz.create('Oskari.mapframework.bundle.mapmodule.request.ZoomToFeaturesRequestHandler', sandbox, me)
    };
  },
  /**
   * @method afterMapLayerRemoveEvent
   * Handle AfterMapLayerRemoveEvent
   *
   * @param {Object} event
   */
  afterMapLayerRemoveEvent: function afterMapLayerRemoveEvent(event) {
    var layer = event.getMapLayer();
    this.removeMapLayerFromMap(layer);
  },
  /**
   * @method removeMapLayerFromMap
   * Remove map layer from map.
   *
   * @param {Oskari.mapframework.domain.VectorLayer} layer the layer
   */
  removeMapLayerFromMap: function removeMapLayerFromMap(layer) {
    if (!this._olLayers[layer.getId()]) {
      return;
    }
    var vectorLayer = this._olLayers[layer.getId()];
    this.getMap().removeLayer(vectorLayer);
    delete this._olLayers[layer.getId()];
    delete this._asyncLayers[layer.getId()];
  },
  /**
   * @method getOLMapLayers
   * Get OpenLayers map layers.
   *
   * @param {Oskari.mapframework.domain.VectorLayer} layer the layer
   */
  getOLMapLayers: function getOLMapLayers(layer) {
    if (!layer.isLayerOfType('VECTOR')) {
      return null;
    }
    var olLayer = this.getLayerById(layer.getId());
    if (!olLayer) {
      return null;
    }
    // only single layer/id, wrap it in an array
    return [olLayer];
  },
  getLayerById: function getLayerById(id) {
    if (!id) {
      return null;
    }
    return this._olLayers[id];
  },
  setVisibleByLayerId: function setVisibleByLayerId(id, visible) {
    var olLayer = this.getLayerById(id);
    if (olLayer) {
      olLayer.setVisible(visible);
    }
    var layer = this._oskariLayers[id];
    if (layer) {
      layer.setVisible(visible);
    }
  },
  /**
   * Possible workaround for arranging the feature draw order within a layer
   *
   */
  rearrangeFeatures: function rearrangeFeatures() {
    var me = this;
    var layers = me.layers;
    for (var key in layers) {
      if (layers[key].features.length > 0) {
        var layer = layers[key];
        var features = layer.features;
        features.sort(function (a, b) {
          if (a.config !== undefined) {
            if (a.config.positionInsideLayer < b.config.positionInsideLayer) {
              return -1;
            }
            if (a.config.positionInsideLayer > b.config.positionInsideLayer) {
              return 1;
            }
          }
          return 0;
        });
        layer.removeAllFeatures();
        layer.addFeatures(features);
      }
    }
  },
  getFeatureId: function getFeatureId(feature) {
    return feature.getId() || feature.get(FTR_PROPERTY_ID);
  },
  _initStyleCache: function _initStyleCache(layerId, featureId) {
    var isUndef = function isUndef(val) {
      return typeof val === 'undefined' || val === null;
    };
    if (isUndef(layerId) || isUndef(featureId)) {
      return;
    }
    var cache = this._styleCache[layerId] || {};
    cache[featureId] = cache[featureId] || {};
    this._styleCache[layerId] = cache;
  },
  getCachedStyles: function getCachedStyles(layerId, featureId) {
    var cache = this._styleCache[layerId];
    if (cache) {
      return cache[featureId];
    }
  },
  updateCachedZIndex: function updateCachedZIndex(layerId, feature, zIndex) {
    if (!layerId || !feature) {
      return;
    }
    var cached = this.getCachedStyles(layerId, this.getFeatureId(feature));
    if (!cached) {
      return;
    }
    this.setStyleZIndex(cached.ol, zIndex);
    this.setStyleZIndex(cached.olHover, zIndex);
  },
  _setFeatureLabel: function _setFeatureLabel(feature, oskariStyle, olStyles) {
    if (!feature || !oskariStyle || !olStyles) {
      return;
    }
    var olText = olStyles.length ? olStyles[0].getText() : undefined;
    if (olText) {
      var labelProp = Oskari.util.keyExists(oskariStyle, 'text.labelProperty') ? oskariStyle.text.labelProperty : '';
      var label = '';
      if (labelProp) {
        if (Array.isArray(labelProp)) {
          labelProp = labelProp.find(function (p) {
            return feature.get(p) !== '';
          });
        }
        label = feature.get(labelProp);
      }
      olText.setText('' + label);
    }
  },
  setFeatureStyle: function setFeatureStyle(options, feature, update) {
    var me = this;
    var layerId = options.layerId;
    var featureId = me.getFeatureId(feature);
    me._initStyleCache(layerId, featureId);
    var olStyles = this.getStyle(options, feature, update);
    // Setup label
    var cached = me.getCachedStyles(layerId, featureId);
    var styleDef = options.featureStyle || {};
    if (cached && cached.oskari) {
      styleDef = cached.oskari;
      delete cached.olHover;
    }
    me._setFeatureLabel(feature, styleDef, olStyles);
    if (update && cached.hoverActive) {
      delete cached.hoverActive;
      me._applyHoverStyle(me._hoverState.feature, me._hoverState.layer);
    } else {
      me._animateFillColorChange(feature, olStyles, options.animationDuration);
    }
  },
  /**
   * @method getStyle
   *
   * @param {Object} options. If option.featureStyle not given, will set default layer styles. If layer style not exist then use defaults.
   * Wanted style object:
   * {
   *     fill: {
   *         color: '#ff0000'
   *     },
   *     stroke: {
   *         color: '#00ff00',
   *         width: 3
   *     },
   *     text: {
   *         fill: {
   *             color: '#0000ff'
   *         },
   *         stroke: {
   *             color: '#ff00ff',
   *             width: 4
   *         }
   *     }
   * }
   * @param {Object} feature ol feature
   * @param {Boolean} update update feature style
   */
  getStyle: function getStyle(options, feature, update) {
    var me = this;
    var cached = me.getCachedStyles(options.layerId, me.getFeatureId(feature));

    // overriding default style with feature/layer style
    var overrideStyle = options.featureStyle || me._layerStyles[options.layerId] || {};
    var baseStyle = update && cached.oskari ? cached.oskari : this._defaultStyle;
    cached.oskari = jQuery.extend(true, {}, baseStyle, overrideStyle);
    // Optional styles based on property values
    if (feature && options.optionalStyles) {
      var optionalStyleDef = me.getOptionalStyle(options.optionalStyles, cached.oskari, feature);
      if (optionalStyleDef) {
        cached.oskari = optionalStyleDef;
      }
    }
    var olStyles = me.getMapModule().getStyle(cached.oskari, null, overrideStyle);
    var zIndex = this.getStyleZIndex(cached.ol);
    this.setStyleZIndex(olStyles, zIndex);
    this.setStyleOpacity(olStyles, options.opacity);
    cached.ol = olStyles;
    return cached.ol;
  },
  setStyleZIndex: function setStyleZIndex() {
    var olStyles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var zIndex = arguments.length > 1 ? arguments[1] : undefined;
    olStyles.forEach(function (style) {
      return style.setZIndex(zIndex);
    });
  },
  setStyleOpacity: function setStyleOpacity() {
    var olStyles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var opacity = arguments.length > 1 ? arguments[1] : undefined;
    if (!this.getMapModule().getSupports3D()) {
      return;
    }
    // apply opacity only for main style. other styles may use aplha for workarounds
    applyOpacityToStyle(olStyles[0], opacity);
  },
  getStyleZIndex: function getStyleZIndex() {
    var olStyles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    // get z index from main style, default to 1
    return olStyles.length ? olStyles[0].getZIndex() : 1;
  },
  /**
   * @method getOptionalStyle
   * Returns a style, if style property value matches to any of feature property values
   * @param {Object} optional style
   * @param {Object} default style
   * @param {Object} feature properties
   * @return
   * */
  getOptionalStyle: function getOptionalStyle(optionalStyles, defStyle, feature) {
    for (var i in optionalStyles) {
      if (filterOptionalStyle(optionalStyles[i], feature)) {
        return jQuery.extend(true, {}, defStyle, optionalStyles[i]);
      }
    }
  },
  /**
   * @method zoomToFeatures
   *  - moves map to show to features on the viewport
   * @param {Object} opts
   * @param {Object} featureFilter
   */
  zoomToFeatures: function zoomToFeatures() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var featureFilter = arguments.length > 1 ? arguments[1] : undefined;
    var layers = this.getLayerIds(opts.layer);
    var features = this.getFeaturesMatchingQuery(layers, featureFilter);
    if (features.length > 0) {
      var tmpLayer = new olSourceVector({
        features: features
      });
      var extent = this.getBufferedExtent(tmpLayer.getExtent(), 35);
      this.getMapModule().zoomToExtent(extent, false, false, opts.maxZoomLevel);
    }
    this.sendZoomFeatureEvent(features);
  },
  /**
   * @method getLayerIds
   * @param {Array|String|Number} layer id or array of layer ids (optional)
   * @return {Array} array of layer ids that was requested and we recognized
   * @see RPC getFeatures
   */
  getLayerIds: function getLayerIds() {
    var layer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    if (!Array.isArray(layer)) {
      // the value for "layer" needs to be an array so wrap it in one if it isn't
      layer = [layer];
    }
    var allLayers = Object.keys(this._olLayers);
    if (!layer.length) {
      // return all layers we know of if layer is not specified
      return allLayers;
    }

    // filtering the requested layers by checking that we know of them
    return layer.filter(function (id) {
      return allLayers.includes(id);
    });
  },
  /**
   * @method getBufferedExtent
   * -  gets buffered extent
   * @param {ol/Extent} extent
   * @param {Number} percentage
   * @return {ol/Extent} extent
   */
  getBufferedExtent: function getBufferedExtent(extent, percentage) {
    var line = new olGeom.LineString([[extent[0], extent[1]], [extent[2], extent[3]]]);
    var buffer = line.getLength() * percentage / 100;
    if (buffer === 0) {
      return extent;
    }
    var geometry = fromExtent(extent);
    var input = olParser.read(geometry);
    var bufferGeometry = BufferOp.bufferOp(input, buffer);
    bufferGeometry.CLASS_NAME = 'jsts.geom.Polygon';
    bufferGeometry = olParser.write(bufferGeometry);
    return bufferGeometry.getExtent();
  },
  /**
   * @method sendZoomFeatureEvent
   *  - sends FeatureEvent with the zoom operation
   * @param {Array} features
   */
  sendZoomFeatureEvent: function sendZoomFeatureEvent(features) {
    var me = this;
    var featureEvent = Oskari.eventBuilder('FeatureEvent')().setOpZoom();
    if (features) {
      var formatter = me._supportedFormats.GeoJSON;
      features.forEach(function (feature) {
        var geojson = formatter.writeFeaturesObject([feature]);
        featureEvent.addFeature(feature.getId(), geojson, feature.layerId);
      });
    }
    me._sandbox.notifyAll(featureEvent);
  },
  /**
   * @method sendZoomFeatureEvent
   *  - sends FeatureEvent with the error operation and error message if given
   * @param {Array} features
   */
  sendErrorFeatureEvent: function sendErrorFeatureEvent(msg) {
    var me = this;
    var featureEvent = Oskari.eventBuilder('FeatureEvent')().setOpError(msg);
    me._sandbox.notifyAll(featureEvent);
  },
  /**
   * @method getFeaturesMatchingQuery
   *  - gets features matching query
   * @param {Array} layers array of layer ids like ['layer1', 'layer2']
   * @param {Object} featureQuery and object like { "id" : [123, "myvalue"] }
   */
  getFeaturesMatchingQuery: function getFeaturesMatchingQuery() {
    var layers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var featureQuery = arguments.length > 1 ? arguments[1] : undefined;
    var me = this;
    var features = [];
    layers.forEach(function (layerId) {
      if (!me._olLayers[layerId]) {
        // invalid layerId
        return;
      }
      var sourceFeatures = me._olLayers[layerId].getSource().getFeatures();
      if (_typeof(featureQuery) !== 'object' || !Object.keys(featureQuery).length) {
        // no query requirements, add all features in layer
        features = features.concat(sourceFeatures);
        return;
      }
      var filteredAndModified = sourceFeatures.filter(function (feature) {
        return Object.entries(featureQuery).some(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            requestedProperty = _ref2[0],
            allowedValues = _ref2[1];
          var featureValue = feature.get(requestedProperty);
          if (typeof featureValue === 'undefined') {
            return false;
          }
          return allowedValues.includes(featureValue);
        });
      }).map(function (f) {
        f.layerId = layerId;
        return f;
      });
      features = features.concat(filteredAndModified);
    });
    return features;
  },
  /**
   * @method getLayerFeatures
   *  - gets layer's features as geojson object
   * @param {String} id
   * @return {Object} geojson
   * @see RPC getFeatures
   */
  getLayerFeatures: function getLayerFeatures(id) {
    var me = this;
    var features = me._olLayers[id].getSource().getFeatures();
    var formatter = me._supportedFormats.GeoJSON;
    var geojson = formatter.writeFeaturesObject(features);
    return geojson;
  },
  /**
   * @method registerRPCFunctions
   * Register RPC functions
   */
  registerRPCFunctions: function registerRPCFunctions() {
    var me = this;
    var sandbox = this._sandbox;
    var rpcService = sandbox.getService('Oskari.mapframework.bundle.rpc.service.RpcService');
    if (!rpcService) {
      return;
    }
    rpcService.addFunction('getFeatures', function (includeFeatures) {
      var features = {};
      var layers = me.getLayerIds();
      layers.forEach(function (id) {
        if (includeFeatures === true) {
          features[id] = me.getLayerFeatures(id);
        } else {
          features[id] = [];
        }
      });
      return features;
    });
  }
}, {
  'extend': ['Oskari.mapping.mapmodule.plugin.AbstractMapModulePlugin'],
  /**
   * @static @property {string[]} protocol array of superclasses
   */
  'protocol': ['Oskari.mapframework.module.Module', 'Oskari.mapframework.ui.module.common.mapmodule.Plugin']
});